import React from 'react';
import styled from '@emotion/styled';
import { OMGTheme } from '@ordermygear/theme';

const TooltipContainer = styled.div`
  display: inline;
  position: absolute;
  width: 320px;
  height: 110px;
  line-height: 1;
  padding: 10px;
  font-size: 12px;
  text-align: left;
  color: white;
  background: ${OMGTheme.colors.grayDark};
  border-radius: 5px;
  text-shadow: rgba(0, 0, 0, 0.1) 1px 1px 1px;
  box-shadow: rgba(0, 0, 0, 0.1) 1px 1px 2px 0px;
  transform: translateX(-50%);
  left: calc(50% + 10px);
  top: -130px;
  display: none;
  h3 {
    font-size: 14px;
    color: white;
    font-weight: 600;
    line-height: 1;
    margin-bottom: 8px;
  }
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.25;
    height: 70px;
  }
  :after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    border-width: 10px;
    border-style: solid;
    border-color: ${OMGTheme.colors.grayDark} transparent transparent transparent;
    top: 110px;
    left: 140px;
  }
`;

interface TooltipProps {
  title: string;
  description: string;
}

const Tooltip: React.FC<TooltipProps> = ({ title, description}) => {
  const descriptionSliced = description ? description.slice(0, 158) : "This status does not have a description.";
  return (
    <TooltipContainer>
      <h3>{title}</h3>
      <p>{descriptionSliced}{descriptionSliced.length >= 158 && '...'}</p>
    </TooltipContainer>
  );
};

export default Tooltip;
